module.exports = __webpack_public_path__ + "static/media/wave.a8aaf0a5.svg";